export default class GetAttachmentRecordByIdError extends Error {

}
